// extracted by mini-css-extract-plugin
module.exports = {"carousel":"SliderComponent_carousel__2w7kz","image":"SliderComponent_image__2yTIV"};